import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import type { marked } from 'marked';

import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { useMarkdown, useMarkdownHTML } from '../../hooks/use-markdown';

import styles from './content-markdown.module.scss';

const style = createStyleHelper(styles, 'content-markdown');

export interface IHeadings {
    level: number;
    title: string;
    id: string;
}

export interface IContentMarkdownProps {
    className?: string;
    markdown: string | marked.TokensList;
    values?: Record<string, unknown>;
}

export const ContentMarkdown: FunctionComponent<IContentMarkdownProps> = ({
    className,
    markdown,
    values,
}) => {
    const intl = useIntl();
    const interpolatedMarkdown = useMemo(() => {
        if (!values || typeof markdown !== 'string') {
            return markdown;
        }

        const message = intl.formatters.getMessageFormat(markdown).format(values);

        if (Array.isArray(message)) {
            return message.join('');
        }

        return message as string;
    }, [markdown, values, intl.formatters]);

    const tokens = useMarkdown(interpolatedMarkdown);
    const html = useMarkdownHTML(tokens);

    return (
        <div
            className={createClassName([className, style()])}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};
